import {
  Datagrid,
  Edit,
  List,
  SimpleForm,
  TextField,
  TextInput,
  BooleanField,
  BooleanInput,
  required,
  useRecordContext,
  NumberField,
  NumberInput,
} from "react-admin";
import { ReferenceArrayInput } from "@components";

interface CourseManagement {
  id: number;
  title: string;
  order: number | null;
  isEnabled: boolean;
  courseGroupsIds: number[];
  externalCourseId: string;
}

const validateRequired = [required()];

const courseManagementFilters = [
  <TextInput key="title" source="title" label="resources.courses-management.fields.title" />,
  <BooleanInput key="isEnabled" source="isEnabled" label="resources.courses-management.fields.isEnabled" />,
];

const GroupsCountField = () => {
  const record = useRecordContext<CourseManagement>();
  return <span>{record?.courseGroupsIds?.length || 0} grupos</span>;
};

export const CourseManagementList = () => (
  <List filters={courseManagementFilters}>
    <Datagrid rowClick="edit" bulkActionButtons={false}>
      <TextField source="id" sortable={false} />
      <TextField source="title" sortable={false} />
      <NumberField source="order" sortable={false} />
      <BooleanField source="isEnabled" sortable={false} />
      <TextField source="externalCourseId" sortable={false} />
      <GroupsCountField />
    </Datagrid>
  </List>
);

const CourseManagementEditForm = () => {
  const record = useRecordContext<CourseManagement>();
  const defaultGroupIds = record?.courseGroupsIds || [];

  return (
    <SimpleForm>
      <TextInput source="title" validate={validateRequired} fullWidth />
      <NumberInput source="order" fullWidth />
      <BooleanInput source="isEnabled" />
      <ReferenceArrayInput 
        source="courseGroupsIds" 
        reference="group"
        defaultValue={defaultGroupIds}
      />
    </SimpleForm>
  );
};

export const CourseManagementEdit = () => {
  return (
    <Edit mutationMode="pessimistic">
      <CourseManagementEditForm />
    </Edit>
  );
}; 